var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUploadIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.56275 6.39038L10.0432 2.82253C10.1759 2.6903 10.3469 2.625 10.5176 2.625C10.711 2.625 10.8753 2.6935 10.9849 2.8152L14.4725 6.39038C14.7247 6.65691 14.7193 7.07588 14.464 7.32067C14.3255 7.44448 14.1672 7.50748 14.0001 7.50748C13.8292 7.50748 13.6575 7.44147 13.5248 7.30905L11.1563 4.89909V13.0113C11.1563 13.3805 10.8693 13.6675 10.5001 13.6675C10.1309 13.6675 9.84385 13.3805 9.84385 13.0113V4.89909L7.47479 7.30968C7.21928 7.5645 6.80216 7.56373 6.58145 7.33075L6.57727 7.32657C6.31235 7.06165 6.31204 6.65529 6.56275 6.39038Z",
    fill: "#2B3D50"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.19385 12.5213C3.19385 12.1521 3.48091 11.865 3.8501 11.865C4.21929 11.865 4.50635 12.1521 4.50635 12.5213V16.625H16.4938V12.5213C16.4938 12.1521 16.7809 11.865 17.1501 11.865C17.5193 11.865 17.8063 12.1521 17.8063 12.5213V17.2813C17.8063 17.6504 17.5193 17.9375 17.1501 17.9375H3.8501C3.48091 17.9375 3.19385 17.6504 3.19385 17.2813V12.5213Z",
    fill: "#2B3D50"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadIcon);
export default __webpack_public_path__ + "static/media/upload-icon.c9254fa54a1f650c60c6fa5abab65c67.svg";
export { ForwardRef as ReactComponent };